// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Mqq8x","icon":"Projects_icon__+FpzK","projectAction":"Projects_projectAction__it1Fg"};